import { LoginRedirectService } from './LoginRedirectService';
import { CacheService } from './CacheService';
import { TokenService } from './TokenService';
import History from './History';
import { ProfileService } from './ProfileService';
import { AccountService } from './AccountService';
import AnalyticsService from './AnalyticsService';
import { CompanyService } from './CompanyService';
import { DataSiteService } from './DataSiteService';
import { ClientAdminService } from './ClientAdminService';
import { ClientAnalyticsService } from './ClientAnalyticsService';
import { CloService } from './CloService';
import { CloDealService } from './CloDealService';
import { UserAdminService } from './UserAdminService';
import { GridService } from './GridService';
import { StaticDataService } from './StaticDataService';
import { SettingsService } from './SettingsService';
import { NewsAdminService } from './NewsAdminService';
import { NewsClientService } from './NewsClientService';
import { DraftCompanyService } from './DraftCompanyService';
import { MsalService } from './MsalService';
import { PlannerNewsService } from './PlannerNewsService';
import { PlannerTranscriptionService } from './PlannerTranscriptionService';
import { TranscriptionsAdminService } from './TranscriptionsAdminService';
import { TranscriptionsClientService } from './TranscriptionsClientService';
import { HelpCenterService } from './HelpCenterService';
import { DocumentsClientService } from './DocumentsClientService';
import { DocumentsAdminService } from './DocumentsAdminService';
import { ReleaseFeatureFlagsService } from './ReleaseFeatureFlagsService';
import { UserClientService } from './UserClientService';
import { ClientService } from './ClientService';
import { UserActivityService } from './UserActivityService';
import { ComplianceService } from './ComplianceService';
import { CovenantReviewService } from '$/services/CovenantReviewService';
import { CovenantReviewQuickFilterTypeService } from '$/services/CovenantReviewQuickFilterTypeService';
import { TagsService } from '$/services/TagsService';

export {
  LoginRedirectService,
  CacheService,
  TokenService,
  History,
  ProfileService,
  AccountService,
  AnalyticsService,
  CompanyService,
  DataSiteService,
  ClientAdminService,
  ClientService,
  ClientAnalyticsService,
  CloService,
  UserAdminService,
  GridService,
  StaticDataService,
  SettingsService,
  NewsAdminService,
  NewsClientService,
  DraftCompanyService,
  MsalService,
  PlannerNewsService,
  PlannerTranscriptionService,
  TranscriptionsAdminService,
  TranscriptionsClientService,
  HelpCenterService,
  DocumentsClientService,
  DocumentsAdminService,
  ReleaseFeatureFlagsService,
  UserClientService,
  UserActivityService,
  ComplianceService,
  CovenantReviewService,
  CovenantReviewQuickFilterTypeService,
  TagsService,
  CloDealService,
};

// Load auth module when browser window loads. Only required for redirect flows.
window.addEventListener('load', async () => {
  MsalService.loadAuthModule();
});
